(() => {
  const button = document.querySelector('[data-haletern-install]');
  if (!button || window.matchMedia('(display-mode: standalone)').matches) return;
  let pendingPrompt;
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    pendingPrompt = event;
    button.hidden = false;
  });
  window.addEventListener('appinstalled', () => {
    pendingPrompt = undefined;
    button.hidden = true;
  });
  button.addEventListener('click', async () => {
    if (!pendingPrompt) return;
    const prompt = pendingPrompt;
    pendingPrompt = undefined;
    button.disabled = true;
    try {
      await prompt.prompt();
      await prompt.userChoice;
    } finally {
      button.hidden = true;
      button.disabled = false;
    }
  });
})();
